/**
 * Reviews carousel: prev/next buttons + dot indicators for the scroll-snap
 * track in sections/cm-reviews.liquid.
 *
 * Scrolling itself stays native (CSS scroll-snap) — this only syncs the dots
 * to the scroll position and moves the track one card per arrow press. Reads
 * card geometry on init/resize, never per scroll frame.
 */
(function () {
  if (window.__cmReviewsInit) return;
  window.__cmReviewsInit = true;

  function setup(root) {
    if (root.dataset.cmReady) return;
    var track = root.querySelector('.cm-reviews__track');
    var cards = root.querySelectorAll('.cm-reviews__card');
    var dots = root.querySelectorAll('.cm-reviews__dot');
    var navs = root.querySelectorAll('.cm-reviews__nav');
    if (!track || !cards.length) return;
    root.dataset.cmReady = '1';

    var prev = navs[0];
    var next = navs[1];
    var ticking = false;

    function step() {
      // Card width + gap — measured live so it survives responsive changes.
      if (cards.length < 2) return cards[0].getBoundingClientRect().width;
      return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    }

    function activeIndex() {
      var s = step();
      if (!s) return 0;
      var i = Math.round(track.scrollLeft / s);
      return Math.max(0, Math.min(cards.length - 1, i));
    }

    function sync() {
      ticking = false;
      var i = activeIndex();
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
      });
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function scrollToIndex(i) {
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }

    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(sync);
      },
      { passive: true }
    );

    if (prev) prev.addEventListener('click', function () { scrollToIndex(activeIndex() - 1); });
    if (next) next.addEventListener('click', function () { scrollToIndex(activeIndex() + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { scrollToIndex(i); });
    });

    window.addEventListener('resize', sync);
    sync();
  }

  function init() {
    document.querySelectorAll('cm-reviews-carousel').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
